import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core'
import { SingleLanguageTitleDescription } from '../../../../generated/graphql'
import Utils from '../../services/utils'
import { TranslateService } from '@ngx-translate/core'
import { ActivatedRoute, Router } from '@angular/router'
import { BaseComponent } from '../base.component'
import { SelfReportService } from '../../services/graphql-services/self-report/self-report.service'

@Component({
  selector: 'app-entity-list',
  templateUrl: './app-entity-list.component.html',
  styleUrls: ['./app-entity-list.component.scss'],
})
export class AppEntityListComponent extends BaseComponent implements OnInit {
  @Input() entities: any[] = []
  @Input() color:
    | 'blue'
    | 'cyan'
    | 'gray'
    | 'green'
    | 'pink'
    | 'white'
    | 'yellow'
    | 'science-organisation'
    | 'artefact'
    | 'content-element' = 'cyan'
  @Input() urlToGoTo: string = ''
  @Input() icon: string = ''
  @Input() showDate = false
  @Output() routerEvent: EventEmitter<any> = new EventEmitter<any>()

  direction = 'ltr'
  sortedEntities: any[] = []

  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public selfReportService: SelfReportService,
  ) {
    super()
    this.handleDirection(translate.currentLang)
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('entities' in changes) {
      this.sortedEntities = [...this.entities]
      this.sortedEntities.sort((x1, x2) => {
        const currentLang = this.translate.currentLang
        const isX1CurrentLang = x1.language === currentLang ? 1 : 0
        const isX2CurrentLang = x2.language === currentLang ? 1 : 0
        if (isX1CurrentLang > isX2CurrentLang) {
          return -1
        } else if (isX1CurrentLang < isX2CurrentLang) {
          return 1
        }

        return x1.sequenceNumber > x2.sequenceNumber ? 1 : -1
      })
    }
  }

  getTranslatedLabelFromTitleAndDescription(
    singleLanguageTitleAndDescriptions: SingleLanguageTitleDescription[],
    key: 'title' | 'description',
  ) {
    return Utils.getTranslated(
      singleLanguageTitleAndDescriptions,
      key,
      this.translate.currentLang,
      this.translate.defaultLang,
    )
  }

  goTo(id: string) {
    this.routerEvent.emit(id)
  }

  private handleDirection(language: string) {
    if (language === 'he') {
      this.direction = 'rtl'
    } else {
      this.direction = 'ltr'
    }
  }
}
